"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _ErrorMessage = require("./ErrorMessage.style");
var _Text = _interopRequireDefault(require("../Text"));
const ErrorMessage = _ref => {
  let {
    message,
    values,
    actionText,
    actionIcon,
    onAction,
    showIcon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ErrorMessage.ErrorWrapper, {
    "data-test-id": message
  }, showIcon && /*#__PURE__*/_react.default.createElement(_ErrorMessage.IconWrapper, null, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "warning",
    color: _uiKit.theme.colours.ERROR
  })), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "Body",
    testId: "error-text-component",
    html: true,
    intlText: message,
    values: values || {}
  }), onAction && /*#__PURE__*/_react.default.createElement(_ErrorMessage.ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    size: "Large",
    onClick: onAction,
    testId: "nav-error-retry"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    intlText: actionText,
    icon: actionIcon
  }))));
};
ErrorMessage.defaultProps = {
  actionText: 'General.Reload',
  onAction: undefined
};
var _default = exports.default = ErrorMessage;